<div class="page-top-bar">
  <a [href]="mainWebsiteURL">
    <img src="/assets/img/logo-dot.png" class="header-logo" alt="Logo image">
  </a>
  <p *ngIf="envName !== 'production'" class="envInfo">
    {{envName}}
  </p>
</div>
